import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => {
  return [
    { fieldName: 'referenceId', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'transactionAa', fieldTitle: t('Αα'), fieldType: 'TEXT' },
    { fieldName: 'transactionDate', fieldTitle: t('Ημ/νία Κίνησης'), fieldType: 'DATE' },
    { fieldName: 'transactionCode', fieldTitle: t('Κωδικός Κίνησης'), fieldType: 'TEXT' },
    { fieldName: 'wasteTransactionType.name', fieldTitle: t('Τύπος Κίνησης'), fieldType: 'TEXT' },
    { fieldName: 'materialName', fieldTitle: t('Απόβλητο'), fieldType: 'TEXT' },
    { fieldName: 'sourceSiteName', fieldTitle: t('Προέλευση Αποβλήτων'), fieldType: 'TEXT' },
    { fieldName: 'destinationSiteName', fieldTitle: t('Προορισμός Αποβλήτων'), fieldType: 'TEXT' },
    { fieldName: 'inputWeight', fieldTitle: t('Εισαγωγή (Kg)'), fieldType: 'TEXT' },
    { fieldName: 'outputWeight', fieldTitle: t('Εξαγωγή (Kg)'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      // const recs = data.getWastereceptionpointTransactionsView.data.map((values) => {
      //   return {
      //     ...values,
      //     isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
      //     firstRec: ` ${
      //       values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
      //     }  - ${values.firstUser}`,
      //     lastRec: ` ${
      //       values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
      //     }  - ${values.lastUser}`,
      //   };
      // });
      // const trsData = {
      //   getWastereceptionpointTransactionsView: {
      //     data: recs,
      //     recordCount: data?.getWastereceptionpointTransactionsView?.recordCount,
      //   },
      // };
      // setResult([get, { loading, data: trsData }]);
      setResult([get, { loading, data }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'Export-WRS-Transactions',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
